//libs
import React, { memo } from 'react';

//styles
import { ColorBox, ImageBox } from './styles';

//defs
import { Value } from 'shared/components/Filter/types';

interface ColorImageProps {
  value: Value;
}

const COLOR_IMAGE_DIMENSION = 20;

const ColorImage = ({ value }: ColorImageProps) => {
  const { color_code = '', color_image, name } = value;

  if (value.color_code) return <ColorBox colorCode={color_code} />;
  else if (color_image)
    return (
      <ImageBox
        src={color_image}
        width={COLOR_IMAGE_DIMENSION}
        height={COLOR_IMAGE_DIMENSION}
        alt={name}
      />
    );
  return null;
};

export default memo(ColorImage);
